
import React, { useState } from "react";

import { useNavigate } from 'react-router-dom';

import { useAuth } from '../../global_state_components/AuthProvider';

import { Navigate } from 'react-router-dom';
import Matrix from "../../Matrix/Matrix";
import BackgroundOverlay from "../../miscellaneous/BackgroundOverlay/BackgroundOverlay";
import SignUpForm from "../SignUpForm/SignUpForm";
import styles from "./signUp.module.css";


function SignUp() {

  const navigate = useNavigate();    //Use the useNavigate hook to programmatically navigate to another route in response to an event (like a button click).
  const { isAuthenticated, setIsAuthenticated} = useAuth();    //Defined in AuthProvider.jsx

  //----------------

  // useEffect(() => {
  //   if (isAuthenticated==='authenticated') {
  //     navigate('/matrix'); // Redirect to matrix page if already signed in
  //   }
  // }, [isAuthenticated, navigate]);



  if (isAuthenticated === 'loading') {
    return <div>Loading...</div>;  // Or a spinner component
  }


  return  (isAuthenticated==='authenticated')? (

    <Navigate to="/matrix"/>

    ):(

    <div>

      <Matrix/>
      <BackgroundOverlay>
        <SignUpForm/>       {/* Form displayed within translucent overlay */}
      </BackgroundOverlay>

    </div>
  );
}


export default SignUp;
